import $ from 'jquery';
import Headroom from 'headroom.js';
import Swiper, {Navigation} from 'swiper';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'parsleyjs/src/parsley';
import 'jquery-form';
import AOS from 'aos';
import LazyLoad from 'vanilla-lazyload';
import autoComplete from '@tarekraafat/autocomplete.js';
import IMask from 'imask'

AOS.init();

new LazyLoad({
    elements_selector: '[data-src]',
    callback_enter: () => {
        AOS.refresh();
    }
});

/*
 * Reviews slider initialization
 */
const swiper = new Swiper('.reviews-slider .swiper', {
    modules: [Navigation],
    spaceBetween: 30,
    autoHeight: true,
    slidesPerView: "auto",
    centeredSlides: true,
    navigation: {
        nextEl: '.reviews-slider .swiper-button-next',
        prevEl: '.reviews-slider .swiper-button-prev',
    },

    breakpoints: {
        320: {
            spaceBetween: 20,
        },
        480: {
            spaceBetween: 30,
        }
    }
});

/*
 * Header initialization
 */
let headroom = new Headroom(document.querySelector(".header"), {
    offset: 80,
    classes: {
        initial: "header",
        pinned: "header--pinned",
        unpinned: "header--unpinned",
        top: "header--top",
        notTop: "header--not-top",
        bottom: "header--bottom",
        notBottom: "header--not-bottom"
    }
});
headroom.init();

/*
 * Calculate footer height
 */
function footer_height() {
    document.querySelector('main').style.setProperty('--footer-height', ($('footer').outerHeight(true) || 0) + 'px');
}

footer_height()
$(window).resize(footer_height);

/*
 * Form validation
 */
document.querySelectorAll('[data-parsley]').forEach(form => {
    $(form).parsley({
        errorClass: "is-invalid",
    }).on('field:error', (e) => {
        $(e.element).siblings('.form-label').addClass('text-danger').removeClass('text-success')
    }).on('field:success', (e) => {
        $(e.element).siblings('.form-label').removeClass('text-danger').addClass('text-success')
    }).on('form:submit', (e) => {
        $(form).ajaxSubmit({
            headers: {
                "Accept": "application/json"
            },
            error: (response) => {
                alert('Error was happened: ' + response.responseJSON.message)
            },
            success: (response) => {
                window.location.replace(response.message);
            },
        });
        return false;
    });
});

/*
 * Start animation
 */
window.addEventListener('load', () => {
    $('body').addClass('animate-first')
});


/*
 * Diver animation
 */
let hero = document.querySelector('.hero')
if (hero) {
    $(document).on('mousemove', function (e) {
        let w = e.view.innerWidth;
        let h = e.view.innerHeight;

        let centerX = w / 2;
        let centerY = h / 2;

        let coefficientX = w * 0.05;
        let coefficientY = h * 0.05;

        let offsetX = parseInt((e.clientX - centerX) / coefficientX);
        let offsetY = parseInt((e.clientY - centerY) / coefficientY);

        hero.style.setProperty('--offset-x', offsetX + 'px');
        hero.style.setProperty('--offset-y', offsetY + 'px');
    })
}


/*
 * Privacy warning
 */
if (!localStorage.getItem('privacy-accepted')) {
    $('.privacy-warning').removeClass('d-none');
}

$(document).on('click', '._js-accept-privacy', function () {
    $(this).closest('.privacy-warning').addClass('d-none')
    localStorage.setItem('privacy-accepted', true);
    return false;
})

$(document).on('click', '._js-reject-privacy', function () {
    $(this).closest('.privacy-warning').addClass('d-none')
    localStorage.setItem('privacy-accepted', true);
    return false;
})

/*
 * Toggle view
 */
function toggleView(el) {
    const container = $(el).closest('._js-toggle-container');

    container.find('[data-toggle-id]').addClass('d-none');
    container.find('[data-toggle-id="' + el.value + '"]').removeClass('d-none');
}

$('._js-toggle-view').change((e) => toggleView(e.target));
$('._js-toggle-view:checked').each((index, el) => toggleView(el))

/*
 * Autocomplete
 */
$("._js-autocomplete").each(function () {
    const autoCompleteJS = new autoComplete({
        selector: '#' + $(this).attr('id'),
        data: {
            src: async (query) => {
                try {
                    const source = await fetch($(this).data('source') + '?q=' + query);
                    const data = await source.json();

                    return data;
                } catch (error) {
                    return error;
                }
            },
            keys: ["country"],
            filter: (list) => {

                return list;
            },
        },
        events: {
            input: {
                focus() {
                    if (autoCompleteJS.input.value.length) autoCompleteJS.start();
                },
                selection(event) {
                    const feedback = event.detail;
                    autoCompleteJS.input.blur();
                    autoCompleteJS.input.value = feedback.selection.value[feedback.selection.key];
                },
            },
        },
    });
});

/*
 * Accordion
 */
[].slice.call(document.querySelectorAll('.accordion:not(.accordion-sections) .collapse')).map(function (el) {
    el.addEventListener('show.bs.collapse', function () {
        $(this).closest('.accordion-item').addClass('is-active');
    })
    el.addEventListener('hide.bs.collapse', function () {
        $(this).closest('.accordion-item').removeClass('is-active');
    })
});

/*
 * Mask
 */
$('[data-mask-money]').each(function() {
    IMask(
        this,
        {
            mask: '$num',
            blocks: {
                num: {
                    // nested masks are available!
                    mask: Number,
                    thousandsSeparator: ','
                }
            }
        });
});
$('[data-mask-date]').each(function() {
    IMask(
        this,
        {
            mask: '0000-00-00'
        }
    );
});
